import { Button, Card, Heading, Paragraph } from '@expressable/syntax-ds';
import { SealQuestion } from '@phosphor-icons/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { routes } from 'router/routes';

type Props = {
  onBailoutToConsult?: () => void;
};

const Component: FC<Props> = ({ onBailoutToConsult }) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const handleClick = () => {
    onBailoutToConsult?.();
    navigate(routes.signupDirect.jotformRedirect);
  };

  return (
    <Card className="my-20 p-e40 mobile-d:p-e32 desktop:my-20 justify-center items-center">
      <Heading level="h6" className="flex items-center -ml-8">
        <div className="p-e12 rounded-full bg-orchid-50 text-purple-500 mx-8">
          <SealQuestion weight="fill" size={20} />
        </div>
        {t('directSignup.schedule.switchToConsult.bailout.heading')}
      </Heading>
      <div className="flex justify-evenly gap-40 md:gap-e56 flex-wrap">
        <Paragraph size="md">{t('directSignup.schedule.switchToConsult.bailout.copy')}</Paragraph>
      </div>
      <Button
        data-testid="check-insurance-eligibility-button"
        size="md"
        variant="secondary"
        className="mt-32"
        onClick={handleClick}
      >
        {t('directSignup.schedule.switchToConsult.CTA')}
      </Button>
    </Card>
  );
};

export const SignupConsultationBailout = Component;
